<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>

      <v-toolbar-title class="pageTitle">
        Fehlzettel
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <v-text-field class="invoice-sf" prepend-inner-icon="mdi-magnify"
                  v-model="searchString"
                  @input="searchTextChange"
                  clearable
    />
    <div class="contentWrapper virtual-padding" ref="contentWrapper">
      <v-virtual-scroll class="order_virtual-scroll" style="padding-bottom: 160px;" item-height="190" v-if="!isLoading" :items="parsedInvoiceLines" bench="1">
        <template v-slot:default="{index, item}">
          <v-card class="articleCard"
                  elevation="0"
                  light
                  :key="index"
          >
            <v-list-item three-line>
              <div style="flex: 0 0 auto; align-self:stretch; min-width: 50px; padding-top: 22px;">
                <span style="flex: 0 0 auto; vertical-align:top;">
                  {{ item.PositionNo }}
                </span>
              </div>
              <v-list-item-avatar tile>
                <v-img :src="item.imgSrc"
                       lazy-src=""
                       contain
                >
                  <template v-slot:placeholder>
                    <v-skeleton-loader type="avatar" tile>

                    </v-skeleton-loader>
                  </template>
                </v-img>
              </v-list-item-avatar>

              <v-list-item-content style="margin-left: 10px;">
                <v-container>
                  <v-row class="articleCard__details">
                    <v-col cols="12"
                           class="articleNameSmall textEllipsis"
                    >
                      {{ item.Description }}
                    </v-col>
                    <div class="articleAdditionalInfoWrapper">
                      <v-col cols="12" class="textSize__14 text--black pb-0 pt-2">
                        <span class="articleAdditionalInfo">Artikelnummer: {{ item.itemNo}}</span>
                      </v-col>
                    </div>
                    <v-col cols="12" v-if="item.availability === 'G'" class="articleStatusCol">
                      <div class="articleAvailable"></div>
                      <span class="articleStatusAvailable">Artikel ist lieferbar</span>
                    </v-col>
                    <v-col cols="12" v-if="item.availability ==='R'" class="articleStatusCol">
                      <div class="articleNotAvailable"></div>
                      <span class="articleStatusNotAvailable"
                            v-if="!item.delisted"
                      >
                          Artikel ist derzeit nicht lieferbar
                        </span>
                      <span class="articleStatusNotAvailable"
                            v-if="item.delisted"
                      >
                          Artikel ist ausgelistet
                        </span>
                    </v-col>
                    <v-col cols="12" v-if="item.availability==='Y'" class="articleStatusCol">
                      <div class="articlePending"></div>
                      <span class="articleStatusPending textEllipsis">Bestellartikel - wird nach Eintreffen automatisch ausgeliefert</span>
                    </v-col>



                    <v-col cols="3">
                      <!--<addToCart :article="item" class="listAddToCartFormButton" v-if="(item.availability === 'G' || item.availability === 'Y') && item.hasMappedProduct"/>-->
                      <addToCart :article="item.itemResult" class="listAddToCartFormButton" v-if="(item.availability === 'G') && item.hasMappedProduct"/>
                    </v-col>

                    <v-col cols="12" class="articleAmountCart">
                      <span>
                        {{ item.MissingAmount }}
                      </span>
                      <span>
                          {{ item.MissingQualifier | capitalize }}
                      </span>
                    </v-col>
                    <!--
                    <v-col cols="12" class="pa-0" v-if="item.NetAmount">
                      <span class="articlePriceMain">Gesamt: {{ item.NetAmount| parsePrice2Digits }} €</span>
                    </v-col>
                    <v-col cols="12" class="pa-0 pt-2" v-if="item.SalesPriceBase">
                      <span class="articleAmountCart">Stückpreis: {{ item.SalesPriceBase| parsePrice2Digits }} €</span>
                      <span class="article-card__price-uvp" v-if="item.RRP" style="margin-left: 5px;">
                        UVP: {{ item.RRP | parsePrice2Digits }} €
                      </span>
                    </v-col>
                    <v-col cols="12" class="pa-0" v-if="!item.NetAmount">
                      <span class="articlePriceMain">-</span>
                    </v-col>
                    <v-col cols="12" class="pa-0 pt-1" v-if="item.LineDiscountPercent">
                      <span class="article-card__price-uvp">Nachlass: {{item.LineDiscountPercent}} %</span>
                    </v-col>
                    -->
                  </v-row>
                </v-container>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </template>
      </v-virtual-scroll>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {api} from "@/config/api";
import axios from "axios";
import AddToCart from "@/app/cart/addToCart.vue";
import { XMLParser } from "fast-xml-parser";
export default {
  name: "MissingItemsDetails",
  components: { AddToCart },
  data() {
    return {
      isLoading: true,
      invoice: [],
      marked_as_received: [],
      searchString: null,
      filterString: null
    }
  },
  methods: {
    searchTextChange(val) {
      setTimeout(() => {
        if(val === this.searchString) {
          this.filterString = val
        }
      }, 300)

    },
    goBack() {
      this.$router.go(-1)
    },
    onCheckboxChange(item, checked) {
      if(checked) {
        this.marked_as_received.push(item.ItemNo)
        const index = this.invoice.findIndex(el => el.itemNo === item.itemNo)
        if(index > -1) {
          this.invoice[index].checked = true
        }
      } else {
        const index = this.marked_as_received.findIndex(el => el === item.itemNo)
        if(index > -1) {
          this.marked_as_received.splice(index, 1)
        }
        const index2 = this.invoice.findIndex(el => el.itemNo === item.itemNo)
        if(index2 > -1) {
          this.invoice[index2].checked = false
        }
      }
    }
  },
  computed: {
    ...mapGetters('invoices', ['getInvoiceData']),
    parsedInvoiceLines () {
      const norm = s => (s || "")
        .toString()
        .toLowerCase()
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, ""); // remove accents

      const terms = norm(this.filterString || "").split(/\s+/).filter(Boolean);
      return this.invoice.filter(el => {
        if (!terms.length) return true; // no filter, keep all

        const desc = norm(el.Description);
        const no   = norm(el.itemNo);

        // every search term must appear in either Description OR itemNo
        return terms.every(term =>
          desc.includes(term) || no.includes(term)
        );
      });
    }
  },
  async mounted() {
    let itemNos = null
    if (!this.getInvoiceData) {
      const result = await axios.get(`api/invoices/show/${this.$route.params.id}`)
      const parser = new XMLParser();
      this.invoice = parser.parse(result.data.invoiceRaw)
      if(this.invoice.Document.MissingItems?.MissingItem && !Array.isArray(this.invoice.Document.MissingItems?.MissingItem)) {
        this.invoice.Document.MissingItems.MissingItem = [this.invoice.Document.MissingItems.MissingItem]
      }
      itemNos = this.invoice.Document.MissingItems.MissingItem.map(item => {
        return item.No.toString().padStart(5, "0");
      })
      this.invoice = this.invoice.Document.MissingItems.MissingItem.map(item => {
        const itemNo = item.No.toString().padStart(5, "0");
        item.imgSrc = `${api.url}storage/webps/${itemNo.indexOf('-') > -1 ? itemNo.substr(0, itemNo.indexOf('-')) : itemNo}.webp`
        return item
      })
    } else {
      this.invoice = this.getInvoiceData.invoiceRaw.MissingItems.MissingItem.map(item => {
        const itemNo = item.No.toString().padStart(5, "0");
        item.imgSrc = `${api.url}storage/webps/${itemNo.indexOf('-') > -1 ? itemNo.substr(0, itemNo.indexOf('-')) : itemNo}.webp`
        return item
      })
      itemNos = this.getInvoiceData.invoiceRaw.MissingItems.MissingItem.map(item => {
        return item.No.toString().padStart(5, "0");
      })
    }


    let itemsResult = await axios.post('api/product-prices', { itemNos: itemNos })
    itemsResult = itemsResult.data

    this.invoice = this.invoice.map(item => {
      const itemNo = item.No.toString().padStart(5, "0");
      item.itemNo = itemNo
      const index = itemsResult.findIndex(el => el.itemNo.toString() === itemNo)
      item.price = itemsResult[index]?.price ?? []
      item.default_price = itemsResult[index]?.default_price ?? {uvp: null}
      item.availability = itemsResult[index]?.availability ?? 'R'
      // item.checked = this.marked_as_received.findIndex(el => el.toString() === itemNo) > -1
      item.delisted = parseInt(itemsResult[index]?.delisted ?? 0) ?? false
      item.NetAmount = item.price[0]?.uvp ?? item.default_price.uvp
      item.baseUnitInPartial = itemsResult[index]?.baseUnitInPartial
      item.baseUnit = itemsResult[index]?.baseUnit
      item.packageItem = parseInt(itemsResult[index]?.packageItem ?? 0)
      item.packageUnit = itemsResult[index]?.packageUnit

      item.hasMappedProduct = !!itemsResult[index]

      item.itemResult = itemsResult[index]


      // missing amount
      // const orderedFullOrPartial = item.Ordered.QuantityBase === item.Ordered.QtyPerUnitOfMeasure ? 'full' : 'partial'
      const missingFullOrPartial = item.Missing.QuantityBase === item.Missing.QtyPerUnitOfMeasure ? 'full' : 'partial'

      if(missingFullOrPartial === 'full') {
        item.MissingAmount = item.Missing.Quantity
        item.MissingQualifier = item.Missing.UnitOfMeasure
      } else {
        item.MissingAmount = item.Missing.QuantityBase
        item.MissingQualifier = item.Missing.BaseUnitOfMeasure
      }

      return item
    }).sort((a, b) => a.PositionNo - b.PositionNo)

    this.isLoading = false
  }
}
</script>

<style scoped>
.v-input .v-input__slot {
  display: none;
}
</style>
